import {
	COLOR_DOT_GAP,
	COLOR_DOT_SIZE,
} from '@/components/blocks/ProductCardSelectColor/styles';
import { useObserverDimensionsElement } from '@/data/hooks/useObserverDimensionsElement';
import { useMemo, useState } from 'react';

interface VisibleColorVariants {
	visibleCount: number;
	overflowCount: number;
	hasOverflow: boolean;
}

const calculateVisibleColorVariants = (
	containerWidth: number,
	totalItems: number,
	itemSize: number,
	gap: number
): VisibleColorVariants => {
	if (containerWidth <= 0) {
		return { visibleCount: totalItems, overflowCount: 0, hasOverflow: false };
	}

	const maxFit = Math.max(Math.floor((containerWidth + gap) / (itemSize + gap)), 1);

	if (totalItems <= maxFit) {
		return { visibleCount: totalItems, overflowCount: 0, hasOverflow: false };
	}

	const visibleCount = Math.max(maxFit - 1, 1);
	return {
		visibleCount,
		overflowCount: totalItems - visibleCount,
		hasOverflow: true,
	};
};

export const useVisibleColorVariants = (
	totalItems: number,
	itemSize: number = COLOR_DOT_SIZE,
	gap: number = COLOR_DOT_GAP
) => {
	const [containerEl, setContainerEl] = useState<Element | null>(null);
	const { width } = useObserverDimensionsElement(containerEl);

	const { visibleCount, overflowCount, hasOverflow } = useMemo(
		() => calculateVisibleColorVariants(width, totalItems, itemSize, gap),
		[width, totalItems, itemSize, gap]
	);

	return { containerRef: setContainerEl, visibleCount, overflowCount, hasOverflow };
};
